<div class="p-3 text-center rounded animated fadeIn blue-grey lighten-5 flex-center">
  <img style="height: 64px;" src="./assets/images/connecting.svg" class="app-wigdet-loading-animate-flicker app-wigdet-loading-shadow">
</div>